import { router } from '@/routes';
import { useRoutes } from 'react-router-dom';

function App() {
  return (
    <>
      {useRoutes(router())}
      {/* <RouterProvider router={router} /> */}
    </>
  );
}

export default App;
